import { Button } from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { headingBlue } from "../../../assets/colors";

const ExcelDownloadButton = ({
  data = [],
  fileName = "table_data.xlsx",
  buttonText = "Download",
  columnMapping = {},
}) => {

  const handleDownload = () => {

    if (!data || data.length === 0) {
      alert("No data available");
      return;
    }

const transformedData = data.map((row) => {
  return {
    Name: row?.name || "",

    Gender: row?.gender || "",

    "Contact Number": row?.contactNumber || "",

    District: row?.district || "",

    Chapter: row?.chapter || "",

    ID: `${row?.chapterCode || ""}${row?._id || ""}`,

    Obligation: row?.obligation
  ? row.obligation
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, str => str.toUpperCase())
      .trim()
  : "",

    "WORKer Type": row?.WORKerType
  ? row.WORKerType
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, str => str.toUpperCase())
      .trim()
  : "",
  };
});

    const worksheet = XLSX.utils.json_to_sheet(transformedData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, fileName);
  };

  return (
    <Button
      variant="contained"
       sx={{
    backgroundColor: headingBlue,
    color: "white",
    marginLeft:"10px",
    "&:hover": {
      backgroundColor: headingBlue,
    }}}
      onClick={handleDownload}
    >
      {buttonText}
    </Button>
  );
};

export default ExcelDownloadButton;